import {
    Button
} from 'shared/components/ui/button';
import {
    schemaExamples
} from './SchemaExamples.ts';
import {
    DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger
} from 'shared/components/ui/dropdown-menu';
import {
    ChevronDown
} from 'lucide-react';

export function SchemaSelector({
    onSelect
}) {
    const handleSelect = (schemaName) => {
        const schema = schemaExamples[schemaName];
        onSelect(JSON.stringify(schema, null, 2));
    };

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="outline" size="sm">
                    <span>Load Example</span>
                    <ChevronDown className="ml-2 h-4 w-4" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                <DropdownMenuItem onClick={() => handleSelect('user')}>User Schema</DropdownMenuItem>
                <DropdownMenuItem onClick={() => handleSelect('product')}>Product Schema</DropdownMenuItem>
                <DropdownMenuItem onClick={() => handleSelect('posts')}>Posts Array Schema</DropdownMenuItem>
                <DropdownMenuItem onClick={() => handleSelect('error')}>Error Schema</DropdownMenuItem>
                <DropdownMenuItem onClick={() => handleSelect('articles')}>Articles (Nested Objects)</DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
